// extracted by mini-css-extract-plugin
export default {"container":"App_container__TXEoH","box":"App_box__zqUPS","visible":"App_visible__DPX8w","preserved":"App_preserved__JawXB"};